




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { getBoUrl } from '@/api/http-constants'

@Component
export default class Groupe extends Vue {
    @Prop() private name?: string
    @Prop() private image: string | number
    @Prop() private sharedSpace: string
    @Prop({ default: 'member' }) private state: 'member' | 'waiting'

    @Prop() private classNames: string
    @Prop() private routerLink: Object
    @Prop({ default: false }) private noLink: boolean
    @Prop() private isPriority?: string

    get _classNames() {
        let classNames = this.classNames
        if (!this.noLink) {
            classNames += ' group-yvivre'
        }
        return classNames
    }

    handleClick(e) {
        this.$emit('click', e)
    }

    groupImageURL(value) {
        const id = parseInt(value, 10)
        const boUrl = getBoUrl()
        if (!isNaN(id)) {
            return `${boUrl}images/groups/yvivre-avatar-group-${value}.jpg`
        } else {
            return `${boUrl}${value}`
        }
    }
}
